import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/api/client";
import { ep } from "@/api/endpoints";
import { qk } from "@/api/queryKeys";
import type { ConversationList } from "@/api/types";
import { useAuthStore } from "@/stores/authStore";

/** GET /api/me/conversations. staleTime 0: 탭에 들어올 때마다 다시 받는다(채팅방에서 돌아오면 순서·미리보기가 바뀌어 있다). */
export function useConversationList() {
  const userId = useAuthStore((s) => s.user?.id ?? "");
  return useQuery({
    queryKey: qk.conversationList(userId),
    queryFn: () => apiFetch<ConversationList>(ep.meConversations),
    enabled: Boolean(userId),
    staleTime: 0,
  });
}
